type VenueCoordinates = {
  latitude?: number | null;
  longitude?: number | null;
};

export const hasValidVenueCoordinates = ({
  latitude,
  longitude,
}: VenueCoordinates) =>
  typeof latitude === "number" &&
  Number.isFinite(latitude) &&
  latitude >= -90 &&
  latitude <= 90 &&
  typeof longitude === "number" &&
  Number.isFinite(longitude) &&
  longitude >= -180 &&
  longitude <= 180;

export const venueMapEmbedUrl = (coordinates: VenueCoordinates) => {
  if (!hasValidVenueCoordinates(coordinates)) return "";
  const latitude = coordinates.latitude!;
  const longitude = coordinates.longitude!;
  const bounds = [
    longitude - 0.008,
    latitude - 0.005,
    longitude + 0.008,
    latitude + 0.005,
  ].join(",");
  return `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(bounds)}&layer=mapnik&marker=${encodeURIComponent(`${latitude},${longitude}`)}`;
};

export const venueDirectionsUrl = (coordinates: VenueCoordinates) => {
  if (!hasValidVenueCoordinates(coordinates)) return "";
  return `https://www.openstreetmap.org/directions?to=${encodeURIComponent(`${coordinates.latitude},${coordinates.longitude}`)}`;
};
